import sanitizeHtml from 'sanitize-html'

export function downloadEmulate(fileName: string, blob: Blob) {
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = sanitizeHtml(url)
  link.setAttribute('download', fileName)

  const element = document.body || document.documentElement

  element.appendChild(link)
  link.click()
  element.removeChild(link)
}
